import React from 'react';

const Loading = () => (
  <div className="dashboard-loading">
    <div className="loading-spinner"></div>
    <p>Loading dashboard data...</p>
  </div>
);

export default Loading;